import axios from "axios";

export const state = {
    topbarNotifications: [],
};

export const mutations = {
    SET_TOPBAR_NOTIFICATIONS(state, notifications) {
        state.topbarNotifications = notifications;
    },
    CLEAR(state) {
        state.topbarNotifications = [];
    },
};


export const getters = {
    notPreviewedTopbarNotificationsCount(state) {
        return state.topbarNotifications.filter(notification => notification.previewed_at === null).length;
    },
}

export const actions = {
    async getTopbarNotifications({commit}) {
        // const response = await axios.get('/notification/topbar');
        // commit('SET_TOPBAR_NOTIFICATIONS', response.data);
    },
    async previewAll({commit, dispatch}) {
        // const response = await axios.post('/notification/topbar/previewAll');
        // commit('SET_TOPBAR_NOTIFICATIONS', response.data);
    },
    async readAll({commit, dispatch}) {
        // const response = await axios.post('/notification/topbar/readAll');
        // commit('SET_TOPBAR_NOTIFICATIONS', response.data);
    },
};
